import { MapPagePresenterContext } from '@Map/FloorMap/Components/MapPage/MapPagePresenter';
import { MiniMapLayoutContent } from '@Map/MiniMap2/MiniLayouts/MiniMapLayout/MiniMapLayoutContent';
import { observer } from 'mobx-react-lite';

import {
  MiniMapLayoutPresenterContext,
  useMiniMapLayoutPresenter,
} from './MiniMapLayoutPresenter';

type MiniMapLayoutProps = {
  floorId: number;
};

export const MiniMapLayout = observer(function MiniMapLayout({
  floorId,
}: MiniMapLayoutProps) {
  const { mapPagePresenter, miniMapLayoutPresenter } =
    useMiniMapLayoutPresenter(floorId);

  if (!miniMapLayoutPresenter) {
    return null;
  }

  return (
    <MiniMapLayoutPresenterContext.Provider value={miniMapLayoutPresenter}>
      <MapPagePresenterContext.Provider value={mapPagePresenter}>
        <MiniMapLayoutContent />
      </MapPagePresenterContext.Provider>
    </MiniMapLayoutPresenterContext.Provider>
  );
});
